import fileSys from "../../fileoprators/fileSystem";
import { INVALID_1000, IMAGESIZE } from "../../shared/consts";
import { logStdout } from "../../shared/utils";
import { FILES, isDefined } from "../shared";
import { nibutInfrared } from "../../fileoprators/license";
import CalCaseDebug from "./CalCaseDebug";

var path = window.require("path");
let pupptr = null;
// const os = window.require('os')

const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));

function initAiNetPtr() {
  if (!global.netPtr) {
    let netrout = fileSys.getUtilPath("cen_v3_pnt_520.mnn");
    let alloc = addonDT.MallocNetPtr(netrout);
    if (alloc.result === 0) global.netPtr = alloc.ptr;
  }
  if (!global.netPtr) {
    return false;
  } else {
    return true;
  }
}
function calCaseData(jpgFileName, eyeType, isRightEye) {
  if (!initAiNetPtr()) {
    return 1;
  }
  let zerkmat = fileSys.getUtilPath("zerkpolyrmat_66_301.bin");
  let caseFolder = path.dirname(jpgFileName) + "/";
  let littleLarge = window.ctShotInfo.shotMode === "far" ? 1 : 0;

  let result = addonDT.InitBaseData(
    eyeType,
    littleLarge,
    caseFolder,
    fileSys.getCalibPath(FILES.calib),
    isRightEye
  );
  let ptr = result.ptr;
  let centxy = new Float64Array(2);
  centxy[0] = parseFloat(window.calibSettings.CenterPoint.x) * 2;
  centxy[1] = parseFloat(window.calibSettings.CenterPoint.y) * 2;
  result = addonDT.ProcessBaseEdges(
    ptr,
    global.netPtr,
    fileSys.getUtilPath() + "/",
    jpgFileName,
    caseFolder,
    centxy.buffer,
    100,
    false
    // xy.buffer
  );
  logStdout("process base edge", result);
  if (result.result === 0) {
    result = addonDT.ProcessBaseSurface(
      ptr,
      fileSys.getCalibPath("") + "/",
      fileSys.getUtilPath("sicomat_66_360.bin"),
      zerkmat,
      caseFolder,
      true
    );
    logStdout("process base surface", result);
    if (result.result === 0) {
      result = addonDT.ProcessModules(ptr);
      logStdout("process modules", result);
    }
  }
  if (result.result === 0) {
    addonDT.FreeBaseData(ptr);
  }

  let ext = path.extname(jpgFileName);
  addonDT.GenThumbail(jpgFileName, jpgFileName.replace(ext, "") + "_th" + ext, 512, 384);
  return result.result;
}
function findPupil(filePath, calibPath) {
  let x = new Float32Array(1);
  let y = new Float32Array(1);
  let r = new Float32Array(1);
  if (isDefined(addonDT.findPupil)) {
    let result = addonDT.findPupil(filePath, calibPath, x, y, z);
    if (result.result === 0) {
      return {
        x: x,
        y: y,
        r: r
      };
    } else {
      return {
        x: INVALID_1000,
        y: INVALID_1000,
        r: INVALID_1000
      };
    }
  } else {
    return {
      x: 10,
      y: 10,
      r: 100
    };
  }
}
function findCornea(filePath, calibPath) {
  let x = new Float32Array(1);
  let y = new Float32Array(1);
  let r = new Float32Array(1);
  if (isDefined(addonDT.findCornea)) {
    let result = addonDT.findCornea(filePath, calibPath, x, y, z);
    if (result.result === 0) {
      return {
        x: x,
        y: y,
        r: r
      };
    } else {
      return {
        x: INVALID_1000,
        y: INVALID_1000,
        r: INVALID_1000
      };
    }
  } else {
    return {
      x: 1024,
      y: 768,
      r: 100
    };
  }
}
function findPupilCornea(filePath) {
  let pixelsize = parseFloat(
    nibutInfrared === true
      ? window.calibSettings.CenterCamCalib.pupilcornea_infrared
      : window.calibSettings.CenterCamCalib.pupilcornea
  );
  let centx = parseFloat(window.calibSettings.CenterPoint.x) * 2;
  let centy = parseFloat(window.calibSettings.CenterPoint.y) * 2;
  let resultInfo = { result: false, pupil: null, cornea: null };
  if (!pupptr) {
    let aipath = fileSys.getUtilPath("pupwtw");
    let aiwtwpath = fileSys.getUtilPath("wtw");
    let pupsegpath = fileSys.getUtilPath("pupseg");
    let wtwpath = fileSys.getUtilPath("wtw");
    let puplocpath = fileSys.getUtilPath("puploc");

    let obj = addonDT.MallocPWNetPtr(pupsegpath, wtwpath, puplocpath);
    if (isDefined(obj) && obj.result === 0 && obj.ptr !== 0) {
      pupptr = obj.ptr;
    } else {
      return resultInfo;
    }
  }
  let outputparas6 = new Float32Array(8);

  outputparas6.fill(INVALID_1000);
  let result = addonDT.UIGetPupilandCorneaXYR(
    filePath,
    pupptr,
    IMAGESIZE.width,
    IMAGESIZE.height,
    pixelsize,
    outputparas6.buffer,
    centx,
    centy
  );

  resultInfo.result = result;
  // if (!result) {
  //   return resultInfo
  // }
  resultInfo.pupil = {
    x: outputparas6[0],
    y: outputparas6[1],
    r: outputparas6[2],
    rx: outputparas6[6],
    ry: outputparas6[7]
  };
  resultInfo.cornea = {
    x: outputparas6[3],
    y: outputparas6[4],
    r: outputparas6[5],
    rx: outputparas6[6],
    ry: outputparas6[7]
  };
  return resultInfo;
}
function findPupilCorneaVideo(filePath, callback) {
  let pixelsize = parseFloat(
    nibutInfrared === true
      ? window.calibSettings.CenterCamCalib.pupilcornea_infrared
      : window.calibSettings.CenterCamCalib.pupilcornea
  );
  fileSys.getUIGetDynamicPupilDiameters(filePath, pixelsize, (data) => {
    callback(data);
  });
}
export const calRings = function (ringType, inImgFullPath, outImgFullPath, inputR, intputOffset) {
  if (!initAiNetPtr()) {
    return false;
  }
  let calibFullPath = fileSys.getCalibPath(FILES.calib);
  let saveImgPath = outImgFullPath + "/";
  let result = addonDT.UICalibRingsCoordinates_all360directions(
    1, // 模拟眼,补偿值为0
    ringType,
    inImgFullPath,
    global.netPtr,
    calibFullPath,
    saveImgPath,
    0, // 补偿值
    95,
    inputR
  ).val;
  logStdout("calculate rings - ring type and result", ringType, result);
  if (result !== 0) return false;
  result = addonDT.UICalibRingsCoordinates_all360directions(
    0, // 人眼,补偿值为输入值
    ringType,
    inImgFullPath,
    global.netPtr,
    calibFullPath,
    saveImgPath,
    intputOffset, // 补偿值
    95,
    inputR
  ).val;
  logStdout("calculate rings - ring type and result:human", ringType, result, intputOffset);
  return result === 0;
};
export default {
  calCaseData,
  findPupil,
  findCornea,
  findPupilCornea,
  findPupilCorneaVideo
};



// WEBPACK FOOTER //
// ./src/topography/js/CalCase.js